
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouter2On as ObiRouter2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-2-on.js';
 
 
 

 
 export const ObiRouter2On = createComponent({
   react: React,
   tagName: 'obi-router-2-on',
   elementClass: ObiRouter2OnElement,
   events: {
     
   }
  });
 
 